export const MAX_WEIGHT = 9999999;